import { GrievanceFormContextType } from '../../services/types/Grievance';
import { serviceReducer } from '../../shared/hooks/serviceReducer';
import { Action, ApiState } from '../../types';

const grievanceReducer = (
  state: ApiState<GrievanceFormContextType, string>,
  action: Action<GrievanceFormContextType, string>
): ApiState<GrievanceFormContextType, string> => serviceReducer(state, action);

export default grievanceReducer;
